import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Heading from 'components/heading';
import Link from 'components/link';

const themes = {
  narrow: 'narrow'
};

const AnchorLinkListBlock = ({ title, links, theme }) => {
  return (
    <div
      className={cn('anchor-link-list', {
        [`anchor-link-list--${theme}`]: themes[theme]
      })}
    >
      <div className="anchor-link-list__title">
        {title && <Heading theme={Heading.themes.h3Portal}>{title}</Heading>}
      </div>
      {links && !!links.length && (
        <ul className="anchor-link-list__list">
          {links.map(link => (
            <li className="anchor-link-list__list-item">
              <Link
                {...link}
                showIcon={true}
                iconIsAfterText={false}
                color={Link.colors.grey}
                theme={Link.themes.anchorLinkBlock}
                animation={Link.animation.expand}
                isAnchorLink={true}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

AnchorLinkListBlock.propTypes = {
  title: PropTypes.string,
  links: PropTypes.arrayOf(Link.propTypes),
  theme: PropTypes.oneOf(Object.keys(themes))
};

AnchorLinkListBlock.propTypesMeta = {
  theme: 'exclude'
};

AnchorLinkListBlock.themes = themes;

export default AnchorLinkListBlock;
